import { render, staticRenderFns } from "./AutoForcedButton.vue?vue&type=template&id=20c0a2fa&scoped=true&"
import script from "./AutoForcedButton.vue?vue&type=script&lang=js&"
export * from "./AutoForcedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0a2fa",
  null
  
)

export default component.exports